import AbstractItem from "./AbstractItem.js";

/**
 * Single report cell data.
 * A cell holds a value for a specific row and column.
 *
 * Row and column lookup is done using their id.
 *
 * @param {object[]} spec.data - Data of the cell
 * @param {row} spec.row - Report row
 * @param {column} spec.column - Report column
 */
export default class Cell extends AbstractItem {
	constructor({ column, row, data }) {
		super(...arguments);
		this._data = data;
		this._column = column;
		this._row = row;
	}

	getData() {
		return this._data || 0;
	}

	setData(data) {
		this._data = data;
	}

	getColumn() {
		return this._column;
	}

	getRow() {
		return this._row;
	}

	getColumnId() {
		return this._column.getId();
	}

	getRowId() {
		return this._row.getId();
	}

	/**
	 * Return the data of the receiver properly formatted.
	 *
	 * The column and the row's own data formatters each have in turn a
	 * chance to override the default formatting, which is set in the
	 * `displaySettings` of the report.
	 */
	getFormattedData({ showDash, defaultFormatter }) {
		if (!this.canBeCalculated()) {
			return "";
		}

		const data = this.getData();
		if (!data && showDash) {
			return "-";
		}

		const row = this.getRow();
		const column = this.getColumn();

		const columnFormatter = column.getFormatter({ defaultFormatter, row });
		const rowFormatter = row.getFormatter({
			defaultFormatter: columnFormatter,
			column,
		});

		return rowFormatter(data);
	}

	canBeCalculated() {
		return (
			this.getRow().canBeCalculated() &&
			this.getColumn().canBeCalculated()
		);
	}

	static transformMaterializationData(data) {
		data.data = data.value;
	}
}
